import { render } from "./MainBlock.vue?vue&type=template&id=6691a73c&ts=true"
import script from "./MainBlock.vue?vue&type=script&lang=ts"
export * from "./MainBlock.vue?vue&type=script&lang=ts"

import "./MainBlock.vue?vue&type=style&index=0&id=6691a73c&lang=scss"

import exportComponent from "/builds/likeacoffee.com/time-assistantv3-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__